import React from "react";
import preloader from '../../assets/images/1_9EBHIOzhE1XfMYoKz1JcsQ.gif'

let Preloader = (props) => {
    return <div style={{backgroungColor: 'white'}}>
        <img src={preloader}/>
    </div>

}

export default Preloader;